var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, TableBody, TableCell, TableRow, Typography, styled, } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WizardTable } from '../common/WizardTable';
var DAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
var CheckboxCell = styled(TableCell)({
    width: '3rem',
    minWidth: '3rem',
    maxWidth: '3rem',
    padding: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
});
var HeaderCheckbox = styled(Checkbox)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0.5),
        color: theme.palette.common.white,
        '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: theme.palette.common.white,
        },
    });
});
export var CopyHoursModal = function (_a) {
    var open = _a.open, sourceDay = _a.sourceDay, onClose = _a.onClose, onConfirm = _a.onConfirm;
    var t = useTranslation('orgConfig', { keyPrefix: 'hours' }).t;
    var tAction = useTranslation('translation', { keyPrefix: 'action' }).t;
    var targetDays = DAY_KEYS.filter(function (key) { return key !== sourceDay; });
    var _b = useState(new Set()), selected = _b[0], setSelected = _b[1];
    useEffect(function () {
        if (open)
            setSelected(new Set());
    }, [open, sourceDay]);
    var sourceDayLabel = t("days.".concat(sourceDay));
    var allSelected = selected.size === targetDays.length;
    var toggleSelectAll = function () {
        if (allSelected) {
            setSelected(new Set());
        }
        else {
            setSelected(new Set(targetDays));
        }
    };
    var toggleDay = function (key) {
        setSelected(function (prev) {
            var next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
            }
            else {
                next.add(key);
            }
            return next;
        });
    };
    var handleConfirm = function () {
        onConfirm(Array.from(selected));
        onClose();
    };
    return (_jsxs(Dialog, __assign({ open: open, onClose: onClose, maxWidth: "xs", fullWidth: true }, { children: [_jsx(DialogTitle, __assign({ component: "div" }, { children: _jsx(Typography, __assign({ variant: "h3" }, { children: t('copyModal.title', { day: sourceDayLabel }) })) })), _jsx(DialogContent, __assign({ sx: { pt: 1 } }, { children: _jsx(WizardTable, __assign({ headers: _jsxs(_Fragment, { children: [_jsx(CheckboxCell, __assign({ align: "center" }, { children: _jsx(HeaderCheckbox, { size: "small", checked: allSelected, indeterminate: selected.size > 0 && !allSelected, onChange: toggleSelectAll, inputProps: { 'aria-label': t('copyModal.selectAll') } }) })), _jsx(TableCell, { children: t('copyModal.selectAll') })] }) }, { children: _jsx(TableBody, { children: targetDays.map(function (day) { return (_jsxs(TableRow, __assign({ hover: true, onClick: function () { return toggleDay(day); }, sx: { cursor: 'pointer' } }, { children: [_jsx(CheckboxCell, __assign({ align: "center" }, { children: _jsx(Checkbox, { size: "small", checked: selected.has(day), onChange: function () { return toggleDay(day); }, onClick: function (e) { return e.stopPropagation(); }, inputProps: { 'aria-label': t("days.".concat(day)) } }) })), _jsx(TableCell, { children: t("days.".concat(day)) })] }), day)); }) }) })) })), _jsxs(DialogActions, __assign({ sx: { justifyContent: 'space-between' } }, { children: [_jsx(Button, __assign({ variant: "outlined", onClick: onClose }, { children: tAction('cancel') })), _jsx(Button, __assign({ variant: "contained", onClick: handleConfirm, disabled: selected.size === 0 }, { children: tAction('apply') }))] }))] })));
};
